import { z } from "zod"

import { stateNameSchema } from "./constants"
import { dateString } from "./form-fields"
import {
  sunlightFirstName,
  sunlightMiddleInitial,
  sunlightLastName,
  sunlightSsn,
  mosaicPhoneNumberFormat,
  sunlightStreet,
  sunlightCity,
  sunlightZipCode,
  sunlightJobTitle,
  sunlightEmployerName,
  sunlightEmploymentMonths,
  sunlightEmploymentYears,
  sunlightAnnualIncome,
} from "./regex"

export const sunlightApplicantSchema = z.object({
  firstName: z
    .string()
    .regex(
      sunlightFirstName,
      `Required.  Cannot contain numbers or special characters.`,
    ),
  middleInitial: z
    .string()
    .regex(
      sunlightMiddleInitial,
      `Cannot contain numbers or special characters and must be 1 character.`,
    )
    .optional()
    .or(z.literal(``)),
  lastName: z
    .string()
    .regex(
      sunlightLastName,
      `Required.  Cannot contain numbers or special characters.`,
    ),
  dateOfBirth: dateString,
  ssn: z
    .string()
    .regex(sunlightSsn, `Required. Must be all numbers formatted: 123456789.`),
  phone: z
    .string()
    .regex(
      mosaicPhoneNumberFormat,
      `Required. Must be all numbers formatted: 1234567890.`,
    ),
  otherPhone: z
    .string()
    .regex(mosaicPhoneNumberFormat, `Must be all numbers formatted: 1234567890.`)
    .optional(),
  email: z.string().email(`Required. Must be a valid email address.`),
  residenceStreet: z
    .string()
    .regex(sunlightStreet, `Required.  Cannot special characters.`),
  residenceCity: z
    .string()
    .regex(sunlightCity, `Required.  Cannot special characters.`),
  residenceStateName: stateNameSchema,
  residenceZipCode: z
    .string()
    .regex(sunlightZipCode, `Required.  Must be in the format 12345.`),
  mailingStreet: z
    .string()
    .regex(sunlightStreet, `Required.  Cannot special characters.`),
  mailingCity: z
    .string()
    .regex(sunlightCity, `Required.  Cannot special characters.`),
  mailingStateName: stateNameSchema,
  mailingZipCode: z
    .string()
    .regex(sunlightZipCode, `Required.  Must be in the format 12345.`),
  isPrimary: z.boolean(),
  jobTitle: z
    .string()
    .regex(sunlightJobTitle, `Required.  Cannot special characters.`),
  employerName: z
    .string()
    .regex(sunlightEmployerName, `Required.  Cannot special characters.`),
  employmentMonths: z
    .string()
    .regex(sunlightEmploymentMonths, `Required.  Must only contain numbers.`),
  employmentYears: z
    .string()
    .regex(sunlightEmploymentYears, `Required.  Must only contain numbers.`),
  annualIncome: z
    .string()
    .regex(sunlightAnnualIncome, `Required.  Must only contain numbers.`),
  isCreditAuthorized: z.boolean().refine((v) => v),
})
export type sunlightApplicantSchema = z.infer<typeof sunlightApplicantSchema>

export const fullSunlightSchema = sunlightApplicantSchema

export type SunlightForm = z.infer<typeof fullSunlightSchema>
